import React from "react";

import { UseFormReturn } from "react-hook-form";

import {
	ManageContentState
} from "./models";

import { Content, } from "models/content";

import {
	Box, Button, IconButton, Stack, Typography
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import UploadIcon from '@mui/icons-material/Upload';

import {
	t,
	Trans
} from "@lingui/macro";

import { withSnackbar, WithSnackbarProps } from "notistack";

import ZPlayLoader from "commons/zplay-loader";

import NavigationBack from "commons/navigation/navigation-back/navigation-back";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { ContentProducerService } from "services/content-producer-service";
import { DefaultTypedResponse } from "models/response";
import ManageContentFilter from "./manage-content-filter/manage-content-filter";
import { Refresh } from "@mui/icons-material";
import { ContentTable } from "components/backoffice/content";
import {ApproveContentRequest} from "../../../models/request/approve-content-request";
import  UploadModal  from "commons/modal/upload-modal";
import {UserType} from "../../../models";

class ManageContent extends React.Component<UseFormReturn & WithSnackbarProps & RouteComponentProps, ManageContentState>
{
	constructor(props: any) {
		super(props);

		this.state = {
			searchFilter: [["pageId", 1], ["pageSize", 20]],
			pagination: { pageSize: 20, pageIndex: 0 },
			contentCount: 0,
			contentList: [],
			data: null,
			loaded: false,
			isUploadModalOpen: false
		};
	}

	public componentDidMount() {

		////****
		//VERY VERY IMPORTANTE! Mongoose Paginate prende di default come prima pagina la pagina 1, mentre la tabella la pagina 0. Serve questo piccolo workaround
		////****
		this.getListContent();
	}

	private getListContent = (): void => {

		ContentProducerService.listContents(this.state.searchFilter, this.getContentCallback, this.getContentErrorCallback);
	}

	private getContentCallback = (data: DefaultTypedResponse<Content>): void => {

		this.setState(() => ({
			contentCount: data.size,
			contentList: data.list,
			loaded: true,
		}));

	};

	private getContentErrorCallback = (err: any): void => {
		this.setState(() => ({
			loaded: false,
		}));
	};

	private parseQueryParamsFromState = (values: any): [string, any][] => {

		let queryParamsToReturn: [string, any][] = [];

		queryParamsToReturn.push(["pageId", this.state.pagination.pageIndex + 1]);
		queryParamsToReturn.push(["pageSize", this.state.pagination.pageSize]);

		if (values.title && values.title !== "")
			queryParamsToReturn.push(["searchText", values.title]);

		if (values.type && values.type !== "")
			queryParamsToReturn.push(["type", values.type]);

		if (values.segregation && values.segregation !== "")
			queryParamsToReturn.push(["segregation", values.segregation]);

		if (values.visibility && values.visibility !== "")
			queryParamsToReturn.push(["visibility", values.visibility]);

		return queryParamsToReturn;
	}

	updateList = (values: any) => {

		this.setState(() => ({ searchFilter: this.parseQueryParamsFromState(values) }));

		ContentProducerService.listContents(this.state.searchFilter, this.getContentCallback, this.getContentErrorCallback);
	};

	private paginationUpdated = (pagination: any) => {

		////****
		//VERY IMPORTANTE! Mongoose Paginate prende di default come prima pagina la pagina 1, mentre la tabella la pagina 0. Serve questo piccolo workaround
		////****

		this.setState(() => ({
			loaded: false,
			pagination: pagination
		}), () => ContentProducerService.listContents([["pageId", this.state.pagination.pageIndex + 1], ["pageSize", this.state.pagination.pageSize]], this.getContentCallback, this.getContentErrorCallback));

	}

	private deleteContent = (id: string): void => {
		this.setState(() => ({
			loaded: false,
		}));

		if ((this.state.contentList.length - 1) % this.state.pagination.pageSize === 0 && this.state.pagination.pageIndex !== 0) {
			this.setState((prevState) => ({
				pagination: {
					...prevState.pagination,
					pageIndex: this.state.pagination.pageIndex - 1
				}
			}));
		};

		ContentProducerService.deleteContent(id, this.deleteContentCallback, this.deleteContentErrorCallback);
	}


	private setMainContentCallback = (id: string): void => {
		this.setState(() => ({
			loaded: false,
		}));
		this.getListContent();
	}

	private setMainContenErorCallback = (id: string): void => {
		this.setState(() => ({
			loaded: true,
		}));
		this.props.enqueueSnackbar(t({
			id: "mc-set-main-content-error",
			message: "Si è verificato un errore. Non è stato possibile impostare il contenuto come principale"
		}), {
			variant: "error",
		});

	}

	private setMainContent = (id: string): void => {
		this.setState(() => ({
			loaded: false,
		}));
		ContentProducerService.setMainContent(id, this.deleteContentCallback, this.deleteContentErrorCallback);
	}

	private deleteContentCallback = (data: DefaultTypedResponse<Content>): void => {

		this.setState(() => ({
			loaded: true,
		}));

		this.getListContent();
	};

	private deleteContentErrorCallback = (err: any): void => {

		this.setState(() => ({
			loaded: true,
		}));

		this.props.enqueueSnackbar(t({
			id: "mc-delete-content-error",
			message: "Si è verificato un errore. Non è stato possibile eliminare il contenuto"
		}), {
			variant: "error",
		});
	};

	private approveContentCallback = (data: DefaultTypedResponse<Content>): void => {

		this.setState(() => ({
			loaded: true,
		}));

		this.getListContent();
	};

	private approveContentErrorCallback = (err: any): void => {
		this.setState(() => ({
			loaded: true,
		}));

		this.props.enqueueSnackbar(t({
			id: "mc-approve-content-error",
			message: "Si è verificato un errore. Non è stato possibile eseguire l'azione"
		}), {
			variant: "error",
		});
	};


	private approveContent = (value: boolean, id: string): void => {
		this.setState(() => ({
			loaded: false,
		}));
		let request: ApproveContentRequest
		if(value)
			request = { action : "approve"}
		else
			request = { action : "reject"}
		ContentProducerService.approveContent(id, request , this.approveContentCallback, this.approveContentErrorCallback);
	}
	
	private goToCreate = (): void => {
		let { history } = this.props
		history.push("/backoffice/content-upload");
	}

	private openUploadModal = () => {
		this.setState(() => ({
			isUploadModalOpen: true
		}))
	}

	private closeUploadModal = () => {
		this.setState(() => ({
			isUploadModalOpen: false
		}))
	}

	private fileToBase64 = (file: File): Promise<string | null>  => {
		return new Promise((resolve, reject) => {
			const reader = new FileReader();

			reader.onload = (event) => {
				if (event.target) {
					const result = event.target.result as string;
					const base64String = result.split(',')[1];
					resolve(base64String);
				} else {
					reject(new Error('Errore nella lettura del file.'));
				}
			};

			reader.onerror = () => {
				reject(new Error('Errore nella lettura del file.'));
			};

			reader.readAsDataURL(file);
		});
	}

	private confirmCsvUpload = async (file: File, userType : UserType) => {

		this.fileToBase64(file).then((base64String) => {
			if (base64String) {
				this.setState(() => ({
					loaded: false,
					isUploadModalOpen: false
				}));
				ContentProducerService.createContentsFromCSV(base64String,this.createContentsFromCSVCallback, this.createContentsFromCSVCallbackError)
			} else {
				this.props.enqueueSnackbar(t({
					id: "mc-convert-csv-file-error",
					message: "Si è verificato un errore. Non è stato possibile processare il file"
				}), {
					variant: "error",
				});
			}
		}).catch((error) => {
			this.props.enqueueSnackbar(t({
				id: "mc-convert-csv-file-error",
				message: "Si è verificato un errore. Non è stato possibile processare il file"
			}), {
				variant: "error",
			});
		});
	}

	private createContentsFromCSVCallback = (contentsWithError: any) => {
		this.setState(() => ({
			loaded: true,
		}));

		if(contentsWithError.contents.length===0 && contentsWithError.parseErrorRow.length===0){
			this.props.enqueueSnackbar(t({
				id: "mc-create-contents-csv-success",
				message: "I contenuti sono stati creati"
			}), {
				variant: "success",
			});
		}else{
			this.props.enqueueSnackbar(t({
				id: "mc-create-contents-csv-warning",
				message: "Si è verificato un errore nella creazione di alcuni content"
			}), {
				variant: "warning",
			});
		}
		this.getListContent();
	}

	private createContentsFromCSVCallbackError = (data: any) => {

		this.setState(() => ({
			loaded: true,
		}));
		this.props.enqueueSnackbar(t({
			id: "mc-create-contents-csv-error",
			message: "Si è verificato un errore, riprova più tardi"
		}), {
			variant: "error",
		});

	}

	render() {
		return (
			<Box sx={{ textAlign: "center", p: 5 }}>
				<NavigationBack/>
				<Typography variant="h2" color={process.env.REACT_APP_DEFAULT_TEXT_COLOR}>
					<Trans id="clb-text-title">Contenuti</Trans>
				</Typography>
				<Box sx={{ p: 2, mt: 4 }}>
					<ManageContentFilter sendDataFn={this.updateList} />
				</Box>
				<Stack direction="row" mt={3} gap={2}>
					<IconButton onClick={() => this.getListContent()}>
						<Refresh color="primary" fontSize="small"/>
					</IconButton>
					<Typography sx={{ flexGrow: 1 }} />
					<Button
							endIcon={<UploadIcon />}
							onClick={this.openUploadModal}
							variant={"contained"}
							size="small"
					>
							<Trans id="mc-button-add-csv">Carica CSV</Trans>
					</Button>
					<Button
							endIcon={<AddIcon />}
							onClick={this.goToCreate}
							variant={"contained"}
							size="small"
					>
							<Trans id="mc-button-add">Aggiungi</Trans>
					</Button>
				</Stack>
				{this.state.loaded && <Box mt={2}>
					<ContentTable
						pagination={this.state.pagination}
						contents={this.state.contentList}
						totalContentCount={this.state.contentCount}
						updatePaginationCallBackFn={this.paginationUpdated}
						deleteContent={this.deleteContent}
						setMainContent={this.setMainContent}
						approveContent={this.approveContent}
					/>
				</Box>}
				{!this.state.loaded && <ZPlayLoader />}
				{this.state.isUploadModalOpen && 
					<UploadModal 
						closeModal={this.closeUploadModal}
						confirmCallback={this.confirmCsvUpload}
				/>}
			</Box>);
	}
}

export default withRouter(withSnackbar(ManageContent));